<h2 mat-dialog-title class="sk-dialog-title">
  <mat-icon>assignment</mat-icon> {{isEdit ? 'Auftrag bearbeiten' : 'Neuer Auftrag'}}
</h2>

<mat-dialog-content class="dialog-content">
  <div class="section-label"><mat-icon class="sk-inline-icon">description</mat-icon> Auftrag</div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Titel</mat-label>
    <input matInput [(ngModel)]="title" required placeholder="z.B. Rohbau Halle 3" cdkFocusInitial>
    <mat-icon matPrefix>assignment</mat-icon>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Beschreibung</mat-label>
    <textarea matInput [(ngModel)]="description" rows="3"></textarea>
  </mat-form-field>

  <div class="form-row">
    <mat-form-field appearance="outline">
      <mat-label>Auftrags-/Bestellnummer</mat-label>
      <input matInput [(ngModel)]="orderNumber">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Einsatzort / Baustelle</mat-label>
      <input matInput [(ngModel)]="location">
      <mat-icon matPrefix>location_on</mat-icon>
    </mat-form-field>
  </div>

  <div class="section-label"><mat-icon class="sk-inline-icon">event</mat-icon> Termine</div>

  <div class="form-row">
    <mat-form-field appearance="outline">
      <mat-label>Auftragseingang</mat-label>
      <input matInput type="date" [(ngModel)]="receivedDate">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Geplanter Beginn</mat-label>
      <input matInput type="date" [(ngModel)]="startDate">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Fertigstellung bis</mat-label>
      <input matInput type="date" [(ngModel)]="dueDate">
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field appearance="outline">
      <mat-label>Bevorzugtes Lager</mat-label>
      <mat-select [(ngModel)]="primaryWarehouseId">
        <mat-option [value]="null">– Kein Lager –</mat-option>
        <mat-option *ngFor="let w of data.linkedWarehouses" [value]="w.id">{{w.name}}</mat-option>
      </mat-select>
      <mat-icon matPrefix>inventory_2</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="isEdit">
      <mat-label>Status</mat-label>
      <mat-select [(ngModel)]="status">
        <mat-option *ngFor="let s of statusOptions" [value]="s">{{statusLabels[s]}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="saving">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="saving || !title.trim()">
    <mat-icon *ngIf="!saving">save</mat-icon>
    {{isEdit ? 'Speichern' : 'Anlegen'}}
  </button>
</mat-dialog-actions>
